var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwaitingSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99396 3.03165C9.99145 3.04002 9.9889 3.0485 9.988 3.058C14.487 3.552 18 7.372 18 12C18 16.963 13.962 21 9 21C4.038 21 0 16.963 0 12C0 7.372 3.513 3.552 8.012 3.058C8.0111 3.0485 8.00855 3.04002 8.00604 3.03165C8.003 3.02151 8 3.01151 8 3V2H7C6.448 2 6 1.553 6 1C6 0.446999 6.448 0 7 0H11C11.552 0 12 0.446999 12 1C12 1.553 11.552 2 11 2H10V3C10 3.01151 9.997 3.02151 9.99396 3.03165ZM9 18.75C5.278 18.75 2.25 15.722 2.25 12C2.25 8.278 5.278 5.25 9 5.25C12.722 5.25 15.75 8.278 15.75 12C15.75 15.722 12.722 18.75 9 18.75ZM13 12C13 11.447 12.552 11 12 11H10V9C10 8.447 9.552 8 9 8C8.448 8 8 8.447 8 9V12C8 12.553 8.448 13 9 13H12C12.552 13 13 12.553 13 12Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwaitingSidebar);
export default __webpack_public_path__ + "static/media/awaitingSidebar.c17bcf8b6349254bf2fce10fa5cb9f05.svg";
export { ForwardRef as ReactComponent };